module.exports = __webpack_public_path__ + "static/media/sj.2ba685bf.webp";